import { Guid } from '@constellation-mutual/guid';

export enum ProviderWorkload {
     fullTime = 'full-time',
     partTime = 'part-time',
}

export type Suffix = 'DDS' | 'DMD';

export interface ProviderIdentity {
     birthDate: string;
     email: string;
     firstName: string;
     lastName: string;
     npi: string | '';
     phone: string | '';
     ssn: string | '';
     suffix: Suffix;
}

export namespace ProviderIdentity {
     export const mock = (): ProviderIdentity => ({
          email: 'user1@domain.com',
          firstName: 'John',
          lastName: 'Doe',
          birthDate: '1980/06/12',
          npi: '',
          phone: '',
          ssn: '1234',
          suffix: 'DDS',
     });
}

export interface ProviderProfile {
     id: Guid;
     nickname: string | '';
     priorActsDate: string;
     procedures: {
          extractsImpactedThirdMolars: boolean;
          injectsBotox: boolean;
          injectsDermalFiller: boolean;
          placesImplants: boolean;
          sedatesElectively: boolean;
     };
     riskIndicators: {
          performanceImpaired: boolean;
          insuranceDenied: boolean;
          licenseLimited: boolean;
          penalizationSought: boolean;
     };
     subspecialtyId: Guid;
     subspecialtyOther: string | '';
     workload: ProviderWorkload;
}

export namespace ProviderProfile {
     export const mock = (): ProviderProfile => ({
          id: '8c125694-fcb7-4bc6-bbb4-27a11a4a24fc',
          nickname: 'Herbert',
          priorActsDate: '2010-06-12',
          procedures: {
               extractsImpactedThirdMolars: false,
               injectsBotox: true,
               injectsDermalFiller: false,
               placesImplants: true,
               sedatesElectively: false,
          },
          riskIndicators: {
               insuranceDenied: false,
               licenseLimited: false,
               penalizationSought: false,
               performanceImpaired: false,
          },
          subspecialtyId: '1e82fe44-e1a1-44b4-b06c-dd804cd0b3e4',
          subspecialtyOther: 'Oral and Maxillofacial Radiologist',
          workload: ProviderWorkload.fullTime,
     });
}

export interface Provider {
     applicationStartedBy?: string;
     applicationFor?: string;
     identity: ProviderIdentity;
     profile: ProviderProfile | null;
     timestampSubmitted?: string;
}

export namespace Provider {
     export const mock = (): Provider => ({
          identity: ProviderIdentity.mock(),
          profile: ProviderProfile.mock(),
     });
}
